import { fmtCLP } from "../../utils/formato";

export default function MobileCartSheet({
  open,
  onClose,
  pedido,
  subtotal,
  totalFinal,
  descuento,
  onEliminarItem,
  onEditarCambios,
  enviando,
}) {
  return (
    <>
      {open && (
        <div
          className="pos-mobile-cart-backdrop"
          onClick={onClose}
          aria-hidden="true"
        />
      )}

      <div className={`pos-mobile-cart-sheet ${open ? "is-open" : ""}`}>
        <div className="pos-mobile-cart-sheet__handle" aria-hidden="true" />
        <div className="pos-mobile-cart-sheet__head">
          <h3 className="pos-mobile-cart-sheet__title">Tu pedido</h3>
          <button
            type="button"
            className="pos-mobile-cart-sheet__close"
            onClick={onClose}
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>

        <div className="pos-mobile-cart-sheet__body">
          {(pedido ?? []).length === 0 ? (
            <p className="muted">No hay productos</p>
          ) : (
            <>
              <ul className="summary__list">
                {pedido.map((it) => {
                  const cambios = String(it.cambios || "").split(/\r?\n/).map((m) => m.trim()).filter(Boolean);
                  return (
                  <li key={`${it.producto_id}-${it.nombre}`} className="summary__row">
                    <div className="summary__info">
                      <div className="summary__name">{it.nombre}</div>
                      <div className="summary__sub">
                        x{it.cantidad} · {fmtCLP(Number(it.precio) * Number(it.cantidad))}
                      </div>
                      {cambios.length > 0 && (
                        <div className="os-item__mods-wrap">
                          <div className="os-item__mods-title">Cambios:</div>
                          <ul className="os-item__mods">
                            {cambios.map((m, idx) => (
                              <li key={`${m}-${idx}`}>{m}</li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                    <button
                      type="button"
                      className="os-item__mod"
                      title="Editar cambios"
                      onClick={() => onEditarCambios?.(it.producto_id, it.nombre)}
                      disabled={enviando}
                    >
                      Cambios
                    </button>
                    <button
                      type="button"
                      className="icon-btn"
                      title="Quitar uno"
                      onClick={() => onEliminarItem(it.producto_id, it.nombre)}
                      disabled={enviando}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
                        <path
                          fill="currentColor"
                          d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7A1 1 0 0 0 5.7 7.11L10.59 12l-4.9 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.9a1 1 0 0 0 1.41-1.41L13.41 12l4.9-4.89a1 1 0 0 0-.01-1.4Z"
                        />
                      </svg>
                    </button>
                  </li>
                );})}
              </ul>
              <div className="summary__totals">
                <div>
                  <span>Subtotal</span>
                  <strong>{fmtCLP(subtotal)}</strong>
                </div>
                {Number(descuento) > 0 && (
                  <div>
                    <span>Descuento</span>
                    <strong>-{fmtCLP(descuento)}</strong>
                  </div>
                )}
                <div className="total-row">
                  <span>Total</span>
                  <strong>{fmtCLP(totalFinal)}</strong>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="pos-mobile-cart-sheet__footer">
          <button type="button" className="btn btn-light full" onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </>
  );
}
